import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorTemplate, {
  ErrorTemplateCode,
} from 'web-library/stories/template/ErrorTemplate/ErrorTemplate';
import Link from 'web-library/stories/atom/Link/Link';
import Typography from 'web-library/stories/atom/Typography/Typography';
import ErrorPageTitle from '../../components/errors/ErrorPageTitle';

import { typographyTheme } from 'web-library/theme/helper/tssHelper';
const useStyles = makeStyles()((theme) => ({
  link: {
    ...typographyTheme(theme, 'h4'),
  },
  subtitleText: {
    color: theme.color.text.textSecondary,
    ...typographyTheme(theme, 'h4'),
  },
}));

const NotExist = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <ErrorTemplate
      errorCode={404 as ErrorTemplateCode}
      title={<ErrorPageTitle label={t('components->>EmptyRoute.PageNotFound')} />}
      subtitle={
        <>
          <Typography className={classes.subtitleText}>
            {t('components->>EmptyRoute.UnableToFindPage')}
          </Typography>
          <Typography className={classes.subtitleText}>
            {t('components->>EmptyRoute.PleaseVisitOur')}{' '}
            <Link className={classes.link} href="/" withUnderline>
              {t('components->>EmptyRoute.homepage')}
            </Link>{' '}
            {t('components->>EmptyRoute.ContinueYourSearchOr')}{' '}
            <Link
              className={classes.link}
              href="https://www.seab.gov.sg/about-us/contact-us/"
              target="_blank"
              rel="noopener noreferrer"
              withUnderline
            >
              {t('components->>EmptyRoute.ContactUs')}
            </Link>
          </Typography>
        </>
      }
    />
  );
};

export default NotExist;
